import React, { ReactElement, useCallback, useState } from 'react';
import { Button, Checkbox, FadeAndSlideTransition, IconButton} from '@framework-controls/core';
import { IconWrench, IconAlertBell, IconWarning, IconHelpCircle } from 'src/content/icons';
import { strings } from 'src/localization';
import * as css from './AdditionalServicePanel.module.scss';
// import ToastBar from 'src/components/ToastBar/containers/ToastBar';
import ToastBar from 'src/components/ToastBar/ToastBar';
import { WebOp, WeOweRec, Recom, Recall, CheckedWeOwe, CheckedRecall, CheckedRecom, DoneElsewhere, SpecData, UpdateApptOpsInp, DeteremineDeptInp, OpType, ApptOps, Appointment, ascCtaInteractionInput, VehicleRec, ascElementConfigurationInput, ApptVeh } from 'src/models';
import AdditionalServicePanelDetail from './AdditionalServicePanelDetail/containers/AdditionalServicePanelDetail';
import { ascCtaInteraction, getElementColor, ascElementConfiguration } from 'src/helpers/EventHelper/EventHelper';
import MoreDetails from 'src/components/MoreDetails/containers/MoreDetails';
import classNames from 'classnames';
import { getProviderId, sendSdEvent } from 'src/helpers/ShiftDigitalHelper/ShiftDigitalHelper';
export interface IProps {
    weOwes: WeOweRec[];
    recalls: Recall[];
    recom: Recom[];
    id: string;
    type: string;
    lit: string;
    checkedWeOwes: CheckedWeOwe[];
    checkedRecalls: CheckedRecall[];
    checkedRecoms: CheckedRecom[];
    doneElsewhere: DoneElsewhere[];
    specData?: SpecData;
    vehLayout?: boolean;
    apptOps: ApptOps[];
    specDefaultDept: string;
    vehicles: VehicleRec[];
    selectedVehicle?: string;
    toggleWeOwe: (id: string) => void;
    toggleRecommended: (id: string) => void;
    toggleRecall: (id: string) => void;
    toggleDoneElsewhere: (id: string) => void;
    UpdateApptOps: (inputOps: UpdateApptOpsInp[]) => void;
    determineDept: (inp: DeteremineDeptInp) => void;
    toggleItem: (id: string) => void;
    appointment: Appointment;
    items: WebOp[];
    setNoAutoRecall: (value: boolean) => void;
    noAutoRecall: boolean;
    theme?: string;
    apptVeh: ApptVeh;
    sessionId: string;
    lexusMCLaunched: string;
    toyotaMCLaunched: string;
    lexusTDMCLaunched: string;
    toyotaTDMCLaunched: string;
    toyotaSSC2Launched: string;
    lexusSSC2Launched: string;
}

const AdditionalServicePanel = (props: IProps) => {
    let serviceIndex = 0;
    let servicePrice = '';
    let serviceDescription = '';
    let toastBarDescription = '';
    let serviceImg: ReactElement | null = <IconWrench />;
    let serviceWhy: ReactElement | string = '';
    let serviceWhat: ReactElement | string = '';
    let serviceComplaintDef: ReactElement | string = '';
    let serviceRank = '';
    let serviceRankText = '';
    let serviceChecked = false;
    let showMessageOnly = false;
    let toastBarType = 'Service';
    let moreDetail: ReactElement | null = null;
    let remedyNotAvailableText = '';
    let iconAlertBell: ReactElement | null = null;
    let iconWarning: ReactElement | null = null;
    let recommendedArea: ReactElement | null = null;
    let doneElsewhereArea: ReactElement | null = null;
    let recallRestricted = '';
    let remedyFlag = '';
    let specialMsg = '';
    const toyLexSSC2Launched =
        props.toyotaSSC2Launched === 'Y' ||
        props.lexusSSC2Launched === 'Y';
    const isSDAnalyticsEnabled =
        props.specData?.toyotaTrackingFlag === 'Y' ||
        props.specData?.lexusTrackingFlag === 'Y' ||
        props.specData?.mbzTrackingFlag === 'Y' ||
        props.specData?.mazdaCATrackingFlag === 'Y' ||
        props.specData?.vwTrackingFlag === 'Y';
    const [toastFlag, setToastFlag] = useState<boolean>(false);
    const [noMoreAutoFlag, setNoMoreAutoFlag] = useState<boolean>(false);
    const [doneElsewhereChecked, setDoneElsewhereChecked] = useState<boolean>(false);
    const rebuildOps = useCallback((serviceType, serviceId) => {
        // Build the opsArray pulling in any ops from the service tab and then update the appointment state
        const opsArrayCopy: UpdateApptOpsInp[] = [...props.apptOps];
        const opsArray: UpdateApptOpsInp[] = [];
        opsArrayCopy.forEach((op) => {
            if (op.opType !== serviceType) {
                opsArray.push(op);
            }
        });

        switch (serviceType) {
            case OpType.RecommendedService:
            default: {
                let apptOps: UpdateApptOpsInp[] = [...props.apptOps];
                const serviceChecked = props.checkedRecoms.some(item => item.opCode === serviceId);

                // If a service is being checked (not currently showing as checked), push it to the ops list
                if (!serviceChecked) {
                    const service = props.recom.filter(item => item.opCode === serviceId);

                    service.forEach((recomService) => {
                        apptOps.push(
                            {
                                id: 'recom' + recomService.opCode,
                                operation: recomService.opCode,
                                concern: recomService.opDesc,
                                estTime: '',
                                menuID: '',
                                spgOp: '',
                                opType: OpType.RecommendedService,
                                itemCostLow: recomService.opPrice,
                                itemCostHigh: recomService.opPrice,
                                department: recomService.department,
                                opWaiter: recomService.opWaiter,
                                opLoaner: recomService.opLoaner,
                                opRental: recomService.opRental,
                                opConcierge: recomService.opConcierge,
                                opCadillac: recomService.opCadillac,
                                opPPUDWL: recomService.opPPUDWL,
                            },
                        );
                    });
                } else {
                    apptOps = apptOps.filter(item => item.operation !== serviceId);
                }
                props.UpdateApptOps(apptOps);
                const defaultDept = props.specDefaultDept;
                const determineDept = {
                    defaultDept: defaultDept,
                };
                props.determineDept(determineDept);
                break;
            }
            case OpType.WeOwe: {
                // Push all checked we-owes except the one being toggled
                const weOweServices = props.weOwes.filter(weOweService => props.checkedWeOwes.find(
                    checkedWeOwe => (checkedWeOwe.weOweDesc === weOweService.weOweDesc) &&
                        (checkedWeOwe.weOweDesc !== serviceId)) !==
                    undefined);
                weOweServices?.forEach((weOweService, index) => {
                    opsArray.push(
                        {
                            id: 'weOwe' + index,
                            operation: '',
                            concern: weOweService.weOweDesc,
                            estTime: '',
                            menuID: '',
                            spgOp: '',
                            opType: OpType.WeOwe,
                            itemCostLow: '0',
                            itemCostHigh: '0',
                            // department: 'S',
                            department: props.specDefaultDept,
                            opWaiter: '',
                            opLoaner: '',
                            opRental: '',
                            opConcierge: '',
                            opCadillac: '',
                            opPPUDWL: '',
                        },
                    );
                });
                // Now, if a service is being checked (not currently showing as checked), push it to the ops list as well
                const opsIndex = weOweServices.length;
                const serviceIndex = props.weOwes.findIndex(result => result.weOweDesc === serviceId);
                const checkedIndex = props.checkedWeOwes.findIndex(result => result.weOweDesc === serviceId);
                if (checkedIndex === -1) {
                    opsArray.push(
                        {
                            id: 'weOwe' + opsIndex,
                            operation: '',
                            concern: props.weOwes[serviceIndex].weOweDesc,
                            estTime: '',
                            menuID: '',
                            spgOp: '',
                            opType: OpType.WeOwe,
                            itemCostLow: '0',
                            itemCostHigh: '0',
                            // department: 'S',
                            department: props.specDefaultDept,
                            opWaiter: '',
                            opLoaner: '',
                            opRental: '',
                            opConcierge: '',
                            opCadillac: '',
                            opPPUDWL: '',
                        },
                    );
                }
                props.UpdateApptOps(opsArray);
                const defaultDept = props.specDefaultDept;
                const determineDept = {
                    defaultDept: defaultDept,
                };
                props.determineDept(determineDept);
                break;
            }
            case OpType.Recall: {
                // Push all checked recalls except the one being toggled
                // Note that campaignNum in the checkedRecalls list is actually the campaignDesc...
                const recallServices = props.recalls.filter(recallService => props.checkedRecalls.find(
                    checkedRecall => (checkedRecall.campaignNum === recallService.campaignDesc) &&
                        (checkedRecall.campaignNum !== serviceId)) !==
                    undefined);
                recallServices?.forEach((recallService, index) => {
                    opsArray.push(
                        {
                            id: 'recall' + index,
                            operation: recallService.campaignNum,
                            concern: recallService.campaignDesc,
                            estTime: '',
                            menuID: '',
                            spgOp: '',
                            opType: OpType.Recall,
                            itemCostLow: '0',
                            itemCostHigh: '0',
                            // department: 'S',
                            department: props.specDefaultDept,
                            opWaiter: '',
                            opLoaner: '',
                            opRental: '',
                            opConcierge: '',
                            opCadillac: '',
                            opPPUDWL: '',
                        },
                    );
                });
                // Now, if a service is being checked (not currently showing as checked), push it to the ops list as well
                const opsIndex = recallServices.length;
                const serviceIndex = props.recalls.findIndex(result => result.campaignDesc === serviceId);
                const checkedIndex = props.checkedRecalls.findIndex(result => result.campaignNum === serviceId);
                if (checkedIndex === -1) {
                    opsArray.push(
                        {
                            id: 'recall' + opsIndex,
                            operation: props.recalls[serviceIndex].campaignNum,
                            concern: props.recalls[serviceIndex].campaignDesc,
                            estTime: '',
                            menuID: '',
                            spgOp: '',
                            opType: OpType.Recall,
                            itemCostLow: '0',
                            itemCostHigh: '0',
                            // department: 'S',
                            department: props.specDefaultDept,
                            opWaiter: '',
                            opLoaner: '',
                            opRental: '',
                            opConcierge: '',
                            opCadillac: '',
                            opPPUDWL: '',
                        },
                    );
                }
                props.UpdateApptOps(opsArray);
                const defaultDept = props.specDefaultDept;
                const determineDept = {
                    defaultDept: defaultDept,
                };
                props.determineDept(determineDept);
                break;
            }
        }
    }, [
        props.apptOps,
        props.checkedRecoms,
        props.recom,
        props.UpdateApptOps,
        props.determineDept,
        props.specDefaultDept,
        props.weOwes,
        props.checkedWeOwes,
        props.recalls,
        props.checkedRecalls,
    ]);

    // If 'Auto Select Recalls' checked, recalls available will be selected except when OEM Recalls
    // is set to 'Show Message Only.' Flags will be set to prevent function from executing when manually
    // toggling recalls in Panel and Menu Cart. Using two flags to prevent an infinite loop within checkAllRecalls.
    const checkAllRecalls = useCallback(() => {
        if (
            props.specData?.autoSelRecall &&
            props.specData?.oemRecall !== 'M' &&
            noMoreAutoFlag === false &&
            props.noAutoRecall === false
        ) {
            switch (props.type) {
                case 'Manufacturer Recall': {
                    const filteredRecalls = (props.recalls ?? []).filter(r => r.remedyFlag === 'Y');
                    const recallOps = filteredRecalls.map((recall, index) => ({
                        id: 'recall' + index,
                        operation: recall.campaignNum,
                        concern: recall.campaignDesc,
                        estTime: '',
                        menuID: '',
                        spgOp: '',
                        opType: OpType.Recall,
                        itemCostLow: '0',
                        itemCostHigh: '0',
                        department: props.specDefaultDept,
                        opWaiter: '',
                        opLoaner: '',
                        opRental: '',
                        opConcierge: '',
                        opCadillac: '',
                        opPPUDWL: '',
                    }));
                    props.UpdateApptOps(recallOps);
                    recallOps.forEach(recall => {
                        props.toggleRecall(recall.concern);
                    });
                    break;
                }
                default:
                    break;
            }
            setNoMoreAutoFlag(true);
        }
    }, [
        props.type,
        props.recalls,
        props.specDefaultDept,
        noMoreAutoFlag,
        props.noAutoRecall,
        props.specData?.autoSelRecall,
        props.specData?.oemRecall,
        props.toggleRecall,
        props.UpdateApptOps,
    ]);
    if (!props.noAutoRecall && props.apptOps.length === 0){
        checkAllRecalls();
    }

    // define the onToggle method
    // Display the Service Added Toast bar
    const onToggle = (e: any, btnText: string) => {
        let serviceChecked = false;
        switch (props.type) {
            case 'We Owe': {
                props.toggleWeOwe(props.id);
                serviceChecked = props.checkedWeOwes.some(item => item.weOweDesc === props.id);
                rebuildOps(OpType.WeOwe, props.id);
                setToastFlag(true);
                setTimeout(setToastFlag, 2000);
                break;
            }
            case 'Recommended Last Visit': {
                props.toggleRecommended(props.id);
                serviceChecked = props.checkedRecoms.some(item => item.opCode === props.id);
                rebuildOps(OpType.RecommendedService, props.id);
                props.toggleItem(props.id);
                if (doneElsewhereChecked) {
                    props.toggleDoneElsewhere(props.id);
                }
                setToastFlag(true);
                setTimeout(setToastFlag, 2000);
                break;
            }
            case 'Manufacturer Recall': {
                if (props.specData?.recallMsg) {
                    setToastFlag(true);
                    setNoMoreAutoFlag(true);
                    props.setNoAutoRecall(true);
                }
                if (props.specData?.recallMsg && props.specData?.oemRecall && props.specData?.oemRecall === 'M') {
                    setTimeout(setToastFlag, 6000);
                    setNoMoreAutoFlag(true);
                    props.setNoAutoRecall(true);
                }
                if (props.specData?.recallMsg && props.specData?.oemRecall && props.specData?.oemRecall !== 'M') {
                    props.toggleRecall(props.id);
                    rebuildOps(OpType.Recall, props.id);
                    setTimeout(setToastFlag, 6000);
                    setNoMoreAutoFlag(true);
                    props.setNoAutoRecall(true);
                }
                if (!props.specData?.recallMsg) {
                    props.toggleRecall(props.id);
                    rebuildOps(OpType.Recall, props.id);
                    setNoMoreAutoFlag(true);
                    props.setNoAutoRecall(true);
                }
                serviceChecked = props.checkedRecalls.some(item => item.campaignNum === props.id);
                break;
            }
            default:
                break;
        }
        const elementColor = getElementColor(e, 'fill');
        const ascCtaInteractionInp : ascCtaInteractionInput = {
            pageType: 'service',
            elementText: btnText ? btnText : serviceDescription,
            elementColor: elementColor,
            elementOrder: '',
            elementType: 'scheduling_tool',
            elementSubType: 'checkbox',
            eventAction: 'click',
            eventActionResult: serviceChecked ? 'uncheck' : 'check',
            linkUrl: '',
        };
        ascCtaInteraction(ascCtaInteractionInp, e, props.vehicles, props.selectedVehicle);
        const ascElementConfigurationInp: ascElementConfigurationInput = {
            pageType: 'service',
            elementText: btnText ? btnText : serviceDescription,
            elementType: 'scheduling_tool',
            elementColor: elementColor,
            eventAction: 'click',
            eventActionResult: serviceChecked ? 'uncheck' : 'check',
            linkUrl: '',
        };
        ascElementConfiguration(ascElementConfigurationInp, e);
        if (isSDAnalyticsEnabled) {
            sendSdEvent('scheduleServiceSelectionStart', {
                scheduleServiceSessionId: props.sessionId,
                scheduleServiceProvider: getProviderId(props.specData, props.toyotaMCLaunched,
                    props.toyotaTDMCLaunched, props.lexusMCLaunched, props.lexusTDMCLaunched),
                scheduleServiceVehicleMake: props.apptVeh.make,
                scheduleServiceVehicleMileage: props.apptVeh.mileage,
                scheduleServiceVehicleModel: props.apptVeh.model,
                scheduleServiceVehicleVin: props.apptVeh.vin,
                scheduleServiceVehicleYear: props.apptVeh.vehYr,
            });
        }
    };

    // define the onDoneElsewhere method
    const onDoneElsewhere = (e: any) => {
        props.toggleDoneElsewhere(props.id);
        if (props.checkedRecoms.some(result => (result.opCode === props.id) ? true : false)) {
            props.toggleRecommended(props.id);
            rebuildOps(OpType.RecommendedService, props.id);
        }
        const elementColor = getElementColor(e, 'fill');
        const ascCtaInteractionInp : ascCtaInteractionInput = {
            pageType: 'service',
            elementText: strings.DoneElsewhere,
            elementColor: elementColor,
            elementOrder: '',
            elementType: 'scheduling_tool',
            elementSubType: 'checkbox',
            eventAction: 'click',
            eventActionResult: !doneElsewhereChecked ? 'check' : 'uncheck',
            linkUrl: '',
        };
        ascCtaInteraction(ascCtaInteractionInp, e, props.vehicles, props.selectedVehicle);
        const ascElementConfigurationInp: ascElementConfigurationInput = {
            pageType: 'service',
            elementText: strings.DoneElsewhere,
            elementType: 'scheduling_tool',
            elementColor: elementColor,
            eventAction: 'click',
            eventActionResult: !doneElsewhereChecked ? 'check' : 'uncheck',
            linkUrl: '',
        };
        ascElementConfiguration(ascElementConfigurationInp, e);
        if (isSDAnalyticsEnabled) {
            sendSdEvent('scheduleServiceSelectionStart', {
                scheduleServiceSessionId: props.sessionId,
                scheduleServiceProvider: getProviderId(props.specData, props.toyotaMCLaunched,
                    props.toyotaTDMCLaunched, props.lexusMCLaunched, props.lexusTDMCLaunched),
                scheduleServiceVehicleMake: props.apptVeh.make,
                scheduleServiceVehicleMileage: props.apptVeh.mileage,
                scheduleServiceVehicleModel: props.apptVeh.model,
                scheduleServiceVehicleVin: props.apptVeh.vin,
                scheduleServiceVehicleYear: props.apptVeh.vehYr,
            });
        }
    };

    switch (props.type) {
        case 'We Owe': {
            serviceIndex = props.weOwes.findIndex(result => result.weOweDesc === props.id);
            serviceDescription = props.weOwes[serviceIndex].weOweDesc;
            servicePrice = '$0.00';
            serviceChecked = props.checkedWeOwes.some(result => (result.weOweDesc === props.id) ? true : false);
            toastBarDescription = serviceDescription + ' - ' + servicePrice;
            break;
        }
        case 'Recommended Last Visit': {
            serviceIndex = props.recom.findIndex(result => result.opCode === props.id);
            serviceDescription = props.recom[serviceIndex].opDesc;
            servicePrice = '$' + (Number(props.recom[serviceIndex].opPrice) / 100).toFixed(2);
            if (servicePrice === '$NaN') {
                servicePrice = strings.CallDealerForPricing;
            }
            const imageIndex = props.recom[serviceIndex].urls.findIndex(result => result.opUrlType === 'I');
            const SvcImgAltTag = props.recom[serviceIndex].opDesc + ' ' + strings.Image;
            if (imageIndex !== -1 && props.recom[serviceIndex].urls[imageIndex].opUrlLink) {
                serviceImg = <img
                    src={props.recom[serviceIndex].urls[imageIndex].opUrlLink}
                    alt={SvcImgAltTag}
                    className={css.serviceImg}>
                </img>;
            }
            serviceWhat = props.recom[serviceIndex].opWhat;
            serviceWhy = props.recom[serviceIndex].opWhy;
            serviceRank = props.recom[serviceIndex].opRank;
            serviceComplaintDef = props.recom[serviceIndex].opComplaintDef;
            if (serviceRank) {
                recommendedArea =
                    <div>
                        {iconAlertBell}
                        {iconWarning}
                        <span className={css.alertText}>
                            {serviceRankText}
                        </span>
                    </div>;
            }
            if (serviceRank === 'R') {
                serviceRankText = strings.RecommendedAlert;
                iconAlertBell = <IconAlertBell className={css.alert} />;
            }
            if (serviceRank === 'Y') {
                serviceRankText = strings.RecommendedWarning;
                iconWarning = <IconWarning className={css.warning} />;
            }
            serviceChecked = props.checkedRecoms.some(result => (result.opCode === props.id) ? true : false);
            if (props.doneElsewhere.some(result => (result.opCode === props.id) ? true : false)) {
                if (!doneElsewhereChecked) {
                    setDoneElsewhereChecked(true);
                }
            } else {
                if (doneElsewhereChecked) {
                    setDoneElsewhereChecked(false);
                }
            }

            toastBarDescription = serviceDescription + ' - ' + servicePrice;

            if (servicePrice === strings.CallDealerForPricing && props.specData?.hidePriceLabel === 'Y') {
                toastBarDescription = serviceDescription;
            }


            const detailsTitleClass = classNames(
                css.detailsTitle,
                {
                    [css.detailsTitleIN]: props.theme === 'infiniti',
                },
            );

            const detailsSalesToolClass = classNames(
                css.detailsSalesTool,
                {
                    [css.detailsSalesToolIN]: props.theme === 'infiniti',
                },
            );

            const detailsPriceClass = classNames(
                css.detailsPrice,
                {
                    [css.detailsPriceDefaultColor]: props.theme === 'mercedesBenz',
                    [css.detailsPriceIN]: props.theme === 'infiniti',
                },
            );

            if (props.specData?.showComplaintDef === 'Y' && serviceComplaintDef) {
                moreDetail = <MoreDetails
                    headerLit={strings.OperationDetails}
                    onAddService={onToggle}
                    addServiceBtn={props.checkedRecoms.findIndex(result => result.opCode === props.id) === -1}
                    vehicles={props.vehicles}
                    selectedVehicle={props.selectedVehicle}>
                    <div
                        className={css.details}>
                        <div className={detailsTitleClass}>
                            {serviceDescription}
                        </div>
                        <div className={css.wrapper}>
                            <div className={css.hr}>
                                <hr />
                            </div>
                            {props.specData?.showCustPrice === 'Y' &&
                                <div className={detailsPriceClass}>
                                    {servicePrice}
                                </div>
                            }
                        </div>
                        <div style={{ display: 'block' }}>
                            <div className={detailsSalesToolClass}>
                                {strings.WhatIsThis}
                            </div>
                            <div className={css.detailsText}>
                                {serviceComplaintDef}
                            </div>
                        </div>
                    </div>
                </MoreDetails>;
            }

            if (serviceWhy || serviceWhat) {
                moreDetail = <div><AdditionalServicePanelDetail serviceIndex={serviceIndex} onToggle={onToggle} /></div>;
            }

            let deCbkClassName = 'primaryCkb';
            if (doneElsewhereChecked) {
                deCbkClassName = 'primaryCkbChecked';
            }

            const doneElsewhereLitStyles = classNames(
                css.doneElsewhereLit,
                {
                    [css.doneElsewhereLitBMW]: props.theme === 'bmw',

                },
            );

            if (props.specData?.allowDoneElsewhere) {
                doneElsewhereArea =
                    <div className={css.doneElsewhereRow}>
                        <span id={'doneElsewhereSpan'} onClick={onDoneElsewhere}>
                            <Checkbox
                                id={'doneElsewhereCheckbox'}
                                size={'rg'}
                                variant={deCbkClassName}
                                checked={doneElsewhereChecked}>
                            </Checkbox>
                        </span>
                        <span className={doneElsewhereLitStyles}>{strings.DoneElsewhere}</span>
                    </div>;
            }
            break;
        }
        case 'Manufacturer Recall': {
            serviceIndex = props.recalls.findIndex(result => result.campaignDesc === props.id);
            serviceDescription = props.recalls[serviceIndex].campaignDesc;
            recallRestricted = props.recalls[serviceIndex].restrFlag;
            remedyFlag = props.recalls[serviceIndex].remedyFlag;
            serviceChecked = props.checkedRecalls.some(result => (result.campaignNum === props.id) ? true : false);
            servicePrice = '$0.00';
            toastBarType = 'Recall';
            if (props.specData?.oemRecall === 'M') {
                showMessageOnly = true;
            }
            toastBarDescription = 'Recall ' + serviceDescription + ' - ' + servicePrice;
            if (recallRestricted) {
                toastBarType = 'RestrRecall';
                specialMsg = props.recalls[serviceIndex].specMessage;
            }
            if (remedyFlag === 'N' && toyLexSSC2Launched) {
                remedyNotAvailableText = strings.RemedyNotAvailable;
            }
            const url = props.recalls[serviceIndex].campaignUrl;
            let updatedUrl = '';

            if (url) {
                updatedUrl = url;
                updatedUrl = `${updatedUrl}#toolbar=0&navpanes=0&scrollbar=0&statusbar=0&view=FitH`;

                moreDetail = <MoreDetails
                    headerLit={strings.RecallDetails}
                    recallDialog={true}
                    vehicles={props.vehicles}
                    selectedVehicle={props.selectedVehicle}>
                    <embed
                        src={updatedUrl}
                        type='application/pdf'
                        className={css.recallPdf}>
                    </embed>
                </MoreDetails>;
            }
            break;
        }
        default:
            break;
    }

    // Set the variant style to be used by the checkbox control based on if it
    // is currently checked or not.
    let cbkClassName = 'primaryCkb';
    if (serviceChecked) {
        cbkClassName = 'primaryCkbChecked';
    }

    let panelButton: JSX.Element | null = (
        <Button id={'serviceCheckbtn'} variant='atext' tooltip={strings.AddSvcTip} onClick={(e: any) => onToggle(e, '')}>
            <Checkbox
                id={'serviceCheckbox'}
                size={'rg'}
                variant={cbkClassName}
                checked={serviceChecked}
            >
            </Checkbox>
        </Button>
    );

    if (recallRestricted) {
        panelButton = (
            <IconButton
                id='recallBtn'
                onClick={() => {
                    setToastFlag(true);
                    setTimeout(setToastFlag, 6000);
                }}
                variant={'help'}>
                <div className={css.question}>
                    <IconHelpCircle />
                </div>
            </IconButton>
        );
    }
    if (remedyNotAvailableText){
        panelButton = null;
    }

    let classes = css.panel + ' ' + (serviceChecked ? css.selected : '');
    if (props.vehLayout) {
        classes = css.panel + ' ' + (serviceChecked ? css.selected : '') + ' ' + css.vehLyoutPanel;
    }

    let CSSleftColumn = css.leftColumn;
    if (serviceChecked) {
        CSSleftColumn = css.leftColumnSelected;
    }

    const typeClass = classNames(
        css.type,
        {
            [css.typeTextColor]: props.theme === 'honda' || props.theme === 'mercedesBenz' || props.theme === 'acura',
            [css.typeTextColorLexusM]: props.theme === 'lexusMonogram',
            [css.typeTextColorGenesis]: props.theme === 'genesis',
        },
    );

    let h4CardId = 'h4Card';
    if (props.theme === 'acura-CA' || props.theme === 'chevrolet' || props.theme === 'honda' ||
        props.theme === 'buick' || props.theme === 'bmw' || props.theme === 'infiniti') {
        h4CardId = 'h4CardSecondary';
    }

    const serviceDiscriptionClass = classNames(
        {
            [css.h4CardMidTextColor]: props.theme === 'nissan' || props.theme === 'mercedesBenz',
        },
    );

    const servicePriceClass = classNames(
        css.price,
        {
            [css.servicePriceSecondary]: props.theme === 'acura-CA' || props.theme === 'chevrolet' || props.theme === 'buick',
            [css.servicePriceDefaultColor]: props.theme === 'mercedesBenz',
            [css.typeTextColor]: props.theme === 'honda' || props.theme === 'subaru',
        },
    );

    return (
        <div className={classes}>
            <div className={css.row}>
                <div className={css.textArea}>
                    <div className={CSSleftColumn}>
                        <div style={{ height: '3rem', width: '3rem' }}>
                            {serviceImg}
                        </div>
                        {props.specData?.showCustPrice === 'Y' &&
                            <div className={servicePriceClass}>
                                {servicePrice}
                            </div>
                        }
                    </div>
                    <div className={css.middleColumn}>
                        <div onClick={!recallRestricted && !remedyNotAvailableText ? (e) => onToggle(e, '') : undefined}>
                            <h4 id={h4CardId}
                                className={serviceDiscriptionClass}>{serviceDescription}</h4>
                            <div className={typeClass}>{props.lit}</div>
                            {recommendedArea}
                        </div>

                        {props.type === 'Manufacturer Recall' && moreDetail}
                        {remedyNotAvailableText && (
                            <h4 className={css.remedyNotAvailable}>
                                {remedyNotAvailableText}
                            </h4>
                        )}
                    </div>
                </div>
                {props.type !== 'Manufacturer Recall' && moreDetail}
                {doneElsewhereArea}
            </div>
            <div className={css.rightColumn}>
                {panelButton}
                <FadeAndSlideTransition
                    in={toastFlag}
                    timeout={{
                        enter: 100,
                        exit: 100,
                    }}
                    isTop={serviceChecked || showMessageOnly || specialMsg ? true : false}
                    zIndex={1000}>
                    <ToastBar
                        type={toastBarType}
                        message={toastBarDescription}
                        specialMsg={specialMsg}
                        specData={props.specData}
                        theme={props.theme}/>
                </FadeAndSlideTransition>
            </div>
        </div>
    );
};

export default AdditionalServicePanel;